export default __webpack_public_path__ + "static/media/arrow-white-left.a738290d.svg";